<div class="full-width">
  <!-- Header -->
  <div class="guts-p-b-1-half skill-header l_flex m-l_flex">
    <h3 class="h3">{{ i18n.Core_Skills }}</h3>
    <a
      class="color-blue par--small font-medium uhover guts-m-l-1-half"
      [routerLink]="['../skills']"
      (click)="trackGoToAllSkills()"
      data-dgat="data-table-new-397"
      [attr.aria-label]="i18n.dgProfileOverview_ViewAllSkills"
      >{{ i18n.Core_ViewAll }}</a
    >
    <button
      *ngIf="isOwner"
      class="guts-m-l-auto add-content-button"
      df-button
      dfButtonType="primary"
      data-dgat="data-table-new-86c"
      (click)="addSkill($event)"
      [attr.aria-label]="i18n.UserController_AddSkills"
    >
      <div class="l_flexbar gap-full-half">
        <df-icon icon="plus"></df-icon>
        <div>{{ i18n.Core_Add }}</div>
      </div>
    </button>
  </div>

  <div class="grid">
    <div class="grid__col-12 guts-p-full-0">
      <div
        class="
          rel
          data-table--sortable-wrapper
          guts-p-h-2 guts-p-t-1-half
          m-guts-p-h-half
        "
      >
        <dgx-tab-navigation-routerless
          [tabList]="tabList"
          [defaultActiveTabId]="skillType"
          wrapperClasses="guts-p-l-0"
          (updateSelectedTab)="switchTab($event)"
        >
        </dgx-tab-navigation-routerless>

        <!-- Pie and Line Charts for Skill Data -->
        <div class="guts-p-v-2">
          <dgx-signal-count-chart
            *ngIf="skills[skillType].length"
            [signalCounts]="signalCounts"
            [skills]="skills[skillType]"
            [currentSkill]="currentSkill"
            [maxSkills]="maxSkills"
          ></dgx-signal-count-chart>

          <dgx-signal-history-chart
            *ngIf="skills[skillType].length"
            class="guts-p-l-3"
            [historyXAxisLabels]="historyXAxisLabels"
            [signalHistories]="signalHistories"
            [skills]="skills[skillType]"
            [currentSkill]="currentSkill"
            [maxSkills]="maxSkills"
          ></dgx-signal-history-chart>
        </div>

        <!-- Table Summary for Skill Data -->
        <table
          class="data-table data-table--sortable"
          [attr.aria-label]="i18n.dgProfileOverview_SkillSignalDataTableLabel"
        >
          <!-- Table Header -->
          <!-- use role="presentation" for the header row so that it is not included in the row count for the table and
               rows are read out with the correct row number when using a screenreader
          -->
          <thead class="a11y-hide" role="presentation">
            <tr>
              <th scope="col">{{ i18n.Core_Skills }}</th>
              <th scope="col">{{ i18n.Core_Ratings }}</th>
              <th scope="col">
                {{ i18n.dgProfileOverview_SkillSignalsTitle }}
              </th>
              <th scope="col">{{ i18n.Core_Actions }}</th>
            </tr>
          </thead>
          <!-- Table Body -->
          <tbody *ngIf="skills[skillType].length > 0">
            <tr
              *ngFor="
                let skill of skills[skillType].slice(0, 6);
                index as skillIndex
              "
              data-dgat="data-table-f16"
              (click)="clickHandler($event, skill)"
              (mouseover)="setCurrentSkill($event, skill)"
              (mouseout)="setCurrentSkill($event, null)"
              [class.cta-row]="isOwner"
              class="table-row clickable"
            >
              <td class="guts-p-l-0 left-text">
                <div class="l_flex l_flex-center-children">
                  <!-- Color Dot (hidden from screenreaders)-->
                  <span
                    class="legend guts-m-r-1 guts-m-l-1"
                    [ngClass]="{
                      'legend--orange': skillIndex === 0,
                      'legend--pink': skillIndex === 1,
                      'legend--ocean': skillIndex === 2,
                      'legend--forest': skillIndex === 3,
                      'legend--purple': skillIndex === 4,
                      'legend--sky': skillIndex === 5
                    }"
                  ></span>
                </div>
              </td>
              <!-- Skill Name Column -->
              <td>
                <div>
                  <!-- Skill Name Link -->
                  <a
                    id="skill-{{ skill.tagId }}"
                    class="h3 break skill-name-link"
                    data-dgat="overview-skills-table-510"
                    routerLink="../signals"
                    [queryParams]="{ tagId: skill.tagId }"
                    >{{ skill.title }}

                    <span
                      *ngIf="skill.userKeyIsFocused"
                      class="a11y-hide-text"
                      >{{ i18n.Core_FocusSkill }}</span
                    >
                  </a>

                  <!-- Focused star -->
                  <df-icon
                    *ngIf="skill.userKeyIsFocused"
                    icon="star"
                    class="color-warning guts-p-l-half"
                    [ngbTooltip]="i18n.Core_FocusSkill"
                  ></df-icon>
                </div>
              </td>

              <!-- Donut rating column -->
              <td>
                <div
                  class="l_flex l_flex-middle guts-p-r-0 donut-rating-column"
                >
                  <dgx-stacked-skill-ratings
                    [skill]="skill"
                    [isOwner]="isOwner"
                  ></dgx-stacked-skill-ratings>
                </div>
              </td>

              <!-- Signal column -->
              <td class="signal-column">
                <dgx-signal-popover
                  [signalSummary]="signalSummaries[skill.resourceId]?.signals"
                  [signalCount]="getSignalCount(skill.resourceId)"
                  [skillName]="skill.name"
                  [isButton]="true"
                  [tag]="skill"
                ></dgx-signal-popover>
              </td>

              <!-- Meatball menu column -->
              <td
                class="
                  guts-p-r-0
                  m-guts-p-l-half m-guts-p-r-1
                  meatball-menu-column
                "
              >
                <dgx-menu
                  [appendToBody]="true"
                  [menuConfig]="getMenuConfig(skill)"
                  placement="bottom-right"
                  [placementAdjustLeftRem]="1"
                  *ngIf="userLoggedIn"
                >
                  <button
                    type="button"
                    (click)="trackMenuOpen($event, skill)"
                    data-dgat="overview-skills-table-e16"
                    [attr.aria-label]="getSkillActionMenuLabel(skill.name)"
                  >
                    <df-icon
                      icon="dots"
                      class="color-ebony-a61 meatball-menu"
                    ></df-icon>
                  </button>
                </dgx-menu>
              </td>
            </tr>
          </tbody>

          <!-- Focus Skills empty state -->
          <tbody *ngIf="skills[skillType].length === 0">
            <div
              class="l_flex l_flex-column l_flex-center-children center-text"
            >
              <div class="guts-p-t-2-half">
                <img
                  [alt]="i18n.Core_Empty_Image_Alt"
                  [src]="emptyImageUrl | blobifyUrl: true"
                  width="360px"
                  height="423px"
                  class="guts-p-b-2"
                />
                <p
                  *ngIf="!isOwner"
                  class="par par--small par--light guts-p-b-3"
                  id="empty-state-viewer-title"
                >
                  {{ i18n.dgProfileOverview_FocusEmptyState_Viewer }}
                </p>
                <div *ngIf="isOwner" class="guts-m-b-3">
                  <p
                    class="par par--small par--light"
                    id="empty-state-owner-title"
                  >
                    {{ i18n.dgProfileOverview_FocusEmptyState_Owner }}
                  </p>
                  <a
                    class="color-blue par--small font-medium uhover"
                    [routerLink]="['../skills']"
                    data-dgat="overview-skills-table-d82"
                    >{{ i18n.dgProfileOverview_FocusEmptyState_Link }}</a
                  >
                </div>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
